import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
